import namespace from '../../config/Namespace';

const types = {
  actions: {
    fetchTickets: 'fetchTickets',
    fetchTicketsSuccess: 'fetchTicketsSuccess',
    fetchTicketsFailure: 'fetchTicketsFailure',
    fetchBalances: 'fetchBalances',
    fetchBalancesSuccess: 'fetchBalancesSuccess',
    fetchBalancesFailure: 'fetchBalancesFailure',
    fetchLibTimes: 'fetchLibTimes',
    fetchLibTimesSuccess: 'fetchLibTimesSuccess',
    fetchLibTimesFailure: 'fetchLibTimesFailure',
    fetchPMSummary: 'fetchPMSummary',
    fetchPMSummarySuccess: 'fetchPMSummarySuccess',
    fetchPMSummaryFailure: 'fetchPMSummaryFailure',
    fetchCashOutBalance: 'fetchCashOutBalance',
    fetchCashOutBalanceSuccess: 'fetchCashOutBalanceSuccess',
    fetchCashOutBalanceFailure: 'fetchCashOutBalanceFailure',
    fetchSignUpRequestDetails: 'fetchSignUpRequestDetails',
    fetchSignUpRequestDetailsSuccess: 'fetchSignUpRequestDetailsSuccess',
    fetchExchangeBoard: 'fetchExchangeBoard',
    fetchExchangeBoardSuccess: 'fetchExchangeBoardSuccess',
    fetchVoucherSummary: 'fetchVoucherSummary',
    fetchVoucherSummarySuccess: 'fetchVoucherSummarySuccess',
    fetchVoucherSummaryFailure: 'fetchVoucherSummaryFailure',
  },
};

export default namespace('dashboard', types);
